<p-toast></p-toast>
<p-toolbar styleClass="border-none">
    <div class="flex flex-1 justify-content-between">
        <div class="flex-1" id="searchBarContainer">
            <span class="p-input-icon-left w-full">
                <i class="ml-1 far fa-magnifying-glass" aria-hidden="true"></i>
                <input type="text" class="w-full" pInputText id="searchBar" [(ngModel)]="searchText"  aria-label="Search events" i18n-aria-label="@@appointment-management-list.navigation.searchBar"
                    (keyup)="onSearchTextChanged($event.target)" />
            </span>
        </div>
        <div>
            <span class="p-buttonGroup">
                <p-button [dt]="whiteButton" (click)="onNewAppointment()" icon="far fa-plus" styleClass="ml-1"
                    *ngIf="hasAnyWriteableCalender()" ariaLabel="Add appointment"
                    i18n-ariaLabel="@@appointment-management-list.buttons.addAppointment"></p-button>

                <p-button [dt]="isfilterActive() ? whiteButtonActive : whiteButton" styleClass="ml-1"
                    (click)="onOpenFilterSettings($event)" icon="far fa-filter"
                    [ariaLabel]="isfilterActive() ? buttonLabels.openFilterOptionDialogNoFilter : buttonLabels.openFilterOptionDialogFilterActive"></p-button>

                <p-button [dt]="getViewButtonStyle()" class="ml-1 "
                    [class.whiteButtonLast]="eventsToGiveFeedback.length == 0" [class.buttonActive]="calendarViewActive"
                    (click)="calendarViewActive = !calendarViewActive; onChangedViewStyle()"
                    icon="far fa-calendar-lines"
                    [ariaLabel]="calendarViewActive ? buttonLabels.listView : buttonLabels.calendarView"></p-button>

                <p-button [dt]="whiteButtonLast" styleClass="ml-1" (click)="onGotoNextPendingFeedbackEvent($event)"
                    icon="far fa-reply-clock feedback-color-info" *ngIf="eventsToGiveFeedback.length>0"
                    ariaLabel="Go to next pending feedback event"
                    i18n-ariaLabel="@@appointment-management-list.buttons.goToNextPendingFeedbackEvent"></p-button>

            </span>

        </div>

    </div>
</p-toolbar>

<h2 #scrollHeader class="text-center font-bold mb-3" style="height:20px"
    [class.hidden]="calendarViewActive || loading==true" [attr.aria-hidden]="calendarViewActive || loading==true" tabindex="-1"></h2>
<div class="flex-1 relative">
    <div class="overflow-y-auto h-full w-full absolute" #scrollable>
        <ng-container *ngIf="!calendarViewActive">
            <div *ngIf="loading == true" class="flex justify-content-center mt-5">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <ng-container *ngIf="loading == false">
                <div *ngIf="appointments.length == 0"
                    class="text-center text-lg font-bold my-5 mx-3 noAppointmentsText">
                    <div i18n="@@appointment-management-list.no-appointments">No event found between
                        {{filterRange.start | date:filterRange.format}} - {{filterRange.end | date:filterRange.format}}
                    </div>
                    <div *ngIf="searchText && searchText!=''"
                        i18n="@@appointment-management-list.no-appointments.forSearch">
                        for your search "{{searchText}}"
                    </div>
                </div>

                <div i18n="@@appointment-management-list.no-calendarActive" *ngIf="this.calendars.length == 0"
                    class="text-center text-lg font-bold mt-7 mb-5 mx-3 noCalendarsText">
                    No calendar created yet or set as 'active' in settings.
                </div>

                <div class="mt-1 mr-3 ml-3 mb-3 appointment" id="{{appointment.id}}"
                    *ngFor="let appointment of appointments; let i = index;">
                    <ng-container
                        *ngIf="i>0 && !moment(appointments[i-1].dateStart).isSame(appointment.dateStart,'month')">
                        <div class="text-center font-bold mb-3 ml-1 mt-3 monthTitle">{{appointment.dateStart |
                            date:"MMMM" }}</div>
                    </ng-container>
                    <p-card [dt]="appointmentCard" styleClass="appointment-card"
                        [class.appointment-in-past]="isInPast(appointment.dateEnd)">
                        <ng-container *ngTemplateOutlet="appointmentTemplate;context:{appointment:appointment, currentPagedImageIndex: appointmentListControl[appointment.id]?.currentPagedImageIndex,
                                collapsed:appointmentListControl[appointment.id]== null || appointmentListControl[appointment.id].collapsed == true,
                                eventRegistrationCollapsed: appointmentListControl[appointment.id]== null || appointmentListControl[appointment.id].eventRegistrationCollapsed == true,
                                showCollapseButton:true
                            }">
                        </ng-container>
                    </p-card>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="calendarViewActive">
            <full-calendar [options]="calendarOptions" [events]="appointmentsForCalendar" #calendar></full-calendar>
        </ng-container>
    </div>
</div>
<div class="flex align-items-center mt-2 mb-2 mr-3 ml-3 dateRange" *ngIf="!calendarViewActive && loading==false">
    <div>
        <p-button icon="far fa-chevron-left" class="p-button-sm rangeButton" (click)="onFilterRangeBack()"
            ariaLabel="Previous events" i18n-ariaLabel="@@appointment-management-list.buttons.previous"
            variant="text"></p-button>
    </div>
    <div class="flex-1 text-center">
        <div class="font-bold rangeText">
            <ng-container *ngIf="isShowPageEnd()">
                {{filterRange.start | date: filterRange.format}}
                <span class="sr-only" i18n="@@appointment-management-list.date.to">to</span>
                <span class="mx-1" aria-hidden="true">-</span> 
                {{filterRange.end | date:filterRange.format}}
            </ng-container>

            <ng-container *ngIf="!isShowPageEnd()">
                {{filterRange.start | date: filterRange.format}}
            </ng-container>
        </div>
    </div>
    <div>
        <p-button icon="far fa-chevron-right" class="p-button-sm rangeButton" (click)="onFilterRangeNext()"
            ariaLabel="Next upcoming events" i18n-ariaLabel="@@appointment-management-list.buttons.next"
            variant="text"></p-button>
    </div>
</div>

<!---->
<div i18n="@@appointment-management-list.embedded" *hasAnyClaim="'embedded'" [ngStyle]="{color:'var(--gray-200)'}"
    class="align-self-end font-semibold mr-3 mb-3 appackLogo" onclick="window.open('https://www.appack.app/');">Powered
    by Appack
</div>

<ng-template #appointmentTemplate let-appointment="appointment" let-collapsed="collapsed"
    let-showCollapseButton="showCollapseButton" let-currentPagedImageIndex="currentPagedImageIndex"
    let-eventRegistrationCollapsed="eventRegistrationCollapsed">
    <div class="flex appointment-card">
        <div class="w-7rem border-right-2 border-black-alpha-10 flex flex-column eventDate" >
            <div class="text-xs calendarColor"
                [style]="{'border-radius':'6px 0px 0px 0px','border-top':'2px solid'+calendarsMap.get(appointment.calendarId)?.color}">
                &nbsp;</div>

            <div class="text-center mb-2 badge" *ngIf="showBadge(appointment) == true">
                <p-tag value="New" i18n-value="@@appointment-management-list.new" severity="danger"></p-tag>
            </div>

            <div class="flex justify-content-center dateContainer" [id]="appointment.id">

                <div class="flex flex-1 flex-column mb-3">
                    <div role="text">
                        <span class="sr-only" i18n="@@appointment-management-list.date.appointmentDate">Date: </span>
                        
                            <div *ngIf="isSameMonth(appointment.dateStart, appointment.dateEnd)" class="text-center text-xl mt-1 font-semibold date">
                                <span class="text-center text-lg weekday w-full">{{appointment.dateStart | date:"cccc"}}</span><br>
                                {{appointment.dateStart |
                                date:"dd.MM."}}<br>
                            </div>
                            <div *ngIf="!isSameMonth(appointment.dateStart, appointment.dateEnd)" class="text-center text-xl mt-1 font-semibold date">
                                <span class="text-center text-lg weekday w-full">{{appointment.dateStart | date:"cccc"}}</span><br>
                                {{appointment.dateStart |
                                date:"dd.MM"}}<br>
                            </div>

                        <div *ngIf="!isSameDay(appointment.dateStart, appointment.dateEnd)">
                            <div class="text-center">
                                <span class="sr-only" i18n="@@appointment-management-list.date.to">to </span>
                                <span aria-hidden="true">-</span>
                            </div>
                            
                            <div *ngIf="isSameMonth(appointment.dateStart, appointment.dateEnd)" class="text-center text-xl mt-1 font-semibold date">
                                <span class="text-center text-lg weekday">{{appointment.dateEnd | date:"cccc"}}</span>
                                {{appointment.dateEnd |
                                date:"dd.MM."}}<br>
                            </div>
                            <div *ngIf="!isSameMonth(appointment.dateStart, appointment.dateEnd)" class="text-center text-xl mt-1 font-semibold date">
                                <span class="text-center text-lg weekday">{{appointment.dateEnd | date:"cccc"}}</span>
                                {{appointment.dateEnd |
                                date:"dd.MM"}}<br></div>
                        </div>


                        <span class="sr-only" i18n="@@appointment-management-list.date.appointmentTime">Time: </span>
                        <div class="flex justify-content-center mt-2 text-xs time" *ngIf="!appointment.allDay">
                            <div>
                                {{appointment.dateStart| date:"HH:mm"}} 
                                <span class="sr-only" i18n="@@appointment-management-list.date.to">to</span>
                                <span class="mx-1" aria-hidden="true">-</span>
                                {{appointment.dateEnd|date:"HH:mm"}}
                                </div>

                        </div>
                        <ng-container *ngIf="appointment.ownRegistrations && appointment.ownRegistrations.length>0">
                            <div class="text-center mt-3 registered"
                                *ngIf="isAllRegistrationsConfirmed(appointment) == true">
                                <p-tag value="Registered" i18n-value="@@appointment-management-list.registered"
                                    severity="success"></p-tag>
                            </div>
                            <div class="text-center mt-2 placeReserved" *ngIf="isReserved(appointment) == true">
                                <p-tag value="Reserved" i18n-value="@@appointment-management-list.reserved"
                                    severity="info"></p-tag>
                            </div>
                            <div class="text-center mt-2 onWaitinglist" *ngIf="waitingLinePosition(appointment) > 0">
                                <p-tag value="Wating list Position: {{waitingLinePosition(appointment)}}"
                                    i18n-value="@@appointment-management-list.waiting-line-position"
                                    severity="warning"></p-tag>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="appointment.ownFeedback">
                            <div class="text-center mt-1 feedback">
                                <ng-container *ngIf="appointment.ownFeedback.status === feedbackType.Positive">
                                    <p class="sr-only"
                                        i18n="@@appointment-management-feedback.participationFeedbackThumbUp">
                                        Participation feedback thumbs-up</p>
                                    <i class="fa-light fa-thumbs-up font-bold m-2 text-2xl feedback-color-success"
                                        aria-hidden="true"></i>
                                </ng-container>
                                <ng-container *ngIf="appointment.ownFeedback.status === feedbackType.Negative">
                                    <p class="sr-only"
                                        i18n="@@appointment-management-feedback.participationFeedbackThumbdown">
                                        Participation feedback thumbs-down</p>
                                    <i class="fa-light fa-thumbs-down font-semibold m-2 text-2xl feedback-color-danger"
                                        aria-hidden="true"></i>
                                </ng-container>
                                <ng-container *ngIf="appointment.ownFeedback.status === feedbackType.Maybe">
                                    <p class="sr-only"
                                        i18n="@@appointment-management-feedback.participationFeedbackMaybe">
                                        Participation feedback maybe</p>
                                    <i class="fa-light fa-question font-semibold m-2 text-2xl feedback-color-warning"
                                        aria-hidden="true"></i>
                                </ng-container>
                                <ng-container *ngIf="appointment.ownFeedback.status === feedbackType.Pending">
                                    <i
                                        class="fa-light fa-reply-clock font-semibold m-2 text-2xl feedback-color-info"></i>
                                    <div class="text-xs font-semibold feedback-color-info"
                                        i18n="@@appointment-management-feedback.pending">Feedback required</div>
                                </ng-container>
                            </div>
                        </ng-container>

                        <div class="text-center mt-2 font-semibold text-xs registrationsMaxSignups"
                            [class.feedback-color-success-text-only]="appointment.registrationCount / (appointment.maxSignUps / 100) <= 50"
                            [class.feedback-color-warning]="appointment.registrationCount / (appointment.maxSignUps / 100) >50"
                            [class.text-pink-500]="appointment.registrationCount >= appointment.maxSignUps"
                            *ngIf="appointment.registrationRequired == true && appointment.maxSignUps">

                            <span *ngIf="appointment.maxSignUps - appointment.registrationCount>0" class="seatsTaken">
                                {{appointment.registrationCount}} 
                                <span class="sr-only" i18n="@@appointment-management-list.date.of">of </span>
                                <span aria-hidden="true">/</span> 
                                {{appointment.maxSignUps}} 
                                <span class="sr-only" i18n="@@appointment-management-list.date.seatsAvailable">Seats taken </span>
                                <span i18n="@@appointment-management-list.registrations.seats" aria-hidden="true">Seats</span>
                            </span>
                            <div class="feedback-color-warning ml-2 mr-2 mt-2 minSignupHintText"
                                *ngIf="appointment.minSignUps != null && appointment.minSignUps > 0 && (appointment.minSignUps - appointment.registrationCount)>0"
                                i18n="@@appointment-management-list.registrations.minSignUpsHint">
                                The event will only take place with a minimum of {{appointment.minSignUps}}
                                participants.
                            </div>
                            <span *ngIf="appointment.maxSignUps - appointment.registrationCount <= 0"
                                style="color:var(--p-red-600)"
                                i18n="@@appointment-management-list.registrations.fullyBooked"
                                class="maxSignupHintText">Fully booked</span>
                        </div>

                        <div *ngIf="appointment.maxSignUps == null && appointment.minSignUps > 0"
                            class="text-center ml-2 mr-2 mt-2 font-semibold text-xs feedback-color-success registrationsOpen">
                            <span>{{appointment.registrationCount}} <span
                                    i18n="@@appointment-management-list.registrations.seats">Seats</span></span>
                            <div class="feedback-color-warning ml-2 mr-2 mt-1 minSignupHintText"
                                *ngIf="appointment.maxSignUps == null && appointment.minSignUps > 0 && (appointment.minSignUps - appointment.registrationCount)>0"
                                style="font-size: .7rem;"
                                i18n="@@appointment-management-list.registrations.minSignUpsHint">
                                The event will only take place with a minimum of {{appointment.minSignUps}}
                                participants.
                            </div>
                        </div>
                    </div>
                    <div class="buttonContainer">
                        <div class="mt-2 flex justify-content-evenly addToCalendarButton"
                            *ngIf="!collapsed && coreLibService.isNativeApp()">
                            <p-button type="button" icon="far fa-calendar-plus" (click)="onAddToCalendar(appointment)"
                                severity="secondary" [text]="true" type="button"
                                ariaLabel="Add appointment to personal calendar"
                                i18n-ariaLabel="@@appointment-management-list.buttons.addAppointmentToPersonalCalendar"></p-button>
                        </div>
                        <div class="mt-1 flex flex-column align-items-center" *ngIf="!collapsed">
                            <p-button [icon]="isFavorite(appointment) ? 'fas fa-star' : 'far fa-star'" [text]="true"
                                type="button" (click)="onToggleFavorite(appointment)" severity="secondary"
                                class="favoriteButton"
                                [ariaLabel]="isFavorite(appointment) ? buttonLabels.removeFromFavorites : buttonLabels.addToFavorites"></p-button>
                            <p-button icon="far fa-list" [text]="true" type="button" class="mt-1 displaySignupsButton"
                                severity="secondary" (click)="onToggleDisplaySignUpOverview(appointment)"
                                *ngIf="showMemberListButton(appointment)" ariaLabel="Participant list"
                                i18n-ariaLabel="@@appointment-management-list.buttons.participantList"></p-button>
                            <p-button icon="far fa-clone" [text]="true" type="button"
                                (click)="onCloneAppointment(appointment)" severity="secondary" class="mt-1 cloneButton"
                                *ngIf="hasWritePersmission(appointment.calendarId)" ariaLabel="Duplicate appointment"
                                i18n-ariaLabel="@@appointment-management-list.buttons.duplicateAppointment"></p-button>
                            <p-button icon="far fa-pen" [text]="true" type="button" (click)="onEditAppointment(appointment)"
                                severity="secondary" *ngIf="hasEventWritePermission(appointment)" class="mt-1 editButton"
                                ariaLabel="Edit appointment"
                                i18n-ariaLabel="@@appointment-management-list.buttons.editAppointment"></p-button>
                            <!-- <button pButton type="button" icon="pi pi-trash" class="p-button-danger"
                                (click)="onDeleteEventDialog(appointment)"
                                *ngIf="hasWritePersmission(appointment.calendarId)"></button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-1 flex-column p-3 overflow-hidden appointmentDetails">
            <div role="text" (click)="onToggleAppointmentDetail(appointment,false)">
                <div class="flex-1 flex align-items-start appointmentDetailsFlex">
                    <div class="flex flex-column w-full" [class.w-8]="appointment.iconImage != null">
                        <div class="text-xs font-medium mb-2 calendarTitle" style="word-break: break-word;">
                            <span class="sr-only" i18n="@@appointment-management-list.calendarRangeIcon">Calendar name:</span>
                            <i class="fa-regular fa-calendar-range mr-2" aria-hidden="true"></i>
                            {{calendarsMap.get(appointment.calendarId)?.title}}
                        </div>
                        <h3 class="text-lg font-medium eventTitle" style="word-break: break-word;">
                            {{appointment.title}}</h3>
                    </div>
                    <div *ngIf="appointment.iconImage != null" class="eventImageBlock border-round">
                        <img class="max-w-full shadow-none eventImage" style="border-radius: 5px; object-fit: cover;"
                            src={{appointment.iconImage.url}} *ngIf="appointment.iconImage != null" loading="lazy"
                            role="presentation" alt="">
                    </div>
                </div>


                <div class="font-light mt-2 eventSubtitle" style="word-break: break-word;">
                    {{appointment.subTitle}}
                </div>

                <div class="mt-2 flex flex-1 justify-content-end text-right flex-wrap"
                    *ngIf="appointment.categories !== null">
                    <div *ngFor="let category of appointment.categories" class="mb-1 categoryContainer">
                        <span class="sr-only" i18n="@@appointment-management-list.appointmentCategory">Category:
                        </span>
                        <p-tag [value]="category.title" [style]="{'background-color':category.color}"
                            class="ml-1 category">
                        </p-tag>
                    </div>
                </div>

                <div class="mt-2 flex flex-1 justify-content-end text-right conferenceContainer"
                    *ngIf="appointment.onlineConference">
                    <span class="sr-only" i18n="@@appointment-management-list.appointmentType">Type:
                    </span>
                    <ng-container *ngIf="appointment.onlineConference">
                        <p-tag value="Online" i18n-value="@@appointment-management-list.onlineConferenceBadge"
                            severity="info"></p-tag>
                    </ng-container>
                </div>
                <p-button *ngIf="collapsed" class="detailsButton sr-only" i18n="appointment-management-list.SROnly.expandButton">Show details</p-button>

            </div>

            <div *ngIf="!collapsed" [@collapse]="collapsed" style="overflow: hidden;"
                class="appointmentDetailsExpanded">
                <div class="w-full mt-4 flex-column justify-content-center" *ngIf="appointment.resources?.length > 0 ">
                    <div class="text-center sm:w-full md:w-5 thumbnail">
                        <p-image [preview]="true" [imageStyle]="{'max-width':'100%','border-radius':'5px'}"
                            [src]="appointment.resources[currentPagedImageIndex]?.url" role="presentation" alt="">
                        </p-image>
                    </div>
                    <p-paginator [first]="currentPagedImageIndex" [rows]="1"
                        [totalRecords]="appointment.resources.length" [alwaysShow]="false"
                        [showJumpToPageDropdown]="false" [showPageLinks]="false" [showFirstLastIcon]="false"
                        (onPageChange)="onImagePagingatorChanged(appointment,$event)" class="detailImages"
                        aria-hidden="true">
                    </p-paginator>
                </div>
                <!--TODO: innerHTML ersetzen, weil die Beschreibung doppelt vorgelesen wird-->
                <div class="mt-4 font-light description appointmentDescription" tabindex="-1" *ngIf="appointment.description">
                    <span style="word-wrap:break-word" [innerHtml]="getSafeHtmlDescription(appointment.description)"></span>
                </div>
                <ng-container *ngIf="appointment.registrationRequired">
                    <div class="mt-4 registrationStarrt" *ngIf="!isStartOfRegistrationReached(appointment)">
                        <label class="font-semibold" i18n="@@appointment-management-list.registration-start">Start of
                            registration</label>
                        <div>{{appointmentStartOfRegistrations[appointment.id] | date:"short"}}</div>
                    </div>
                    <div class="mt-4 registrationEnd" *ngIf="appointmentDeadLines[appointment.id]">
                        <label class="font-semibold"
                            i18n="@@appointment-management-list.registration-deadline">Registration
                            deadline</label>
                        <div>{{appointmentDeadLines[appointment.id] | date:"short"}}</div>
                    </div>
                </ng-container>

                <div *ngIf="appointment.location" class="mt-4 flex location">
                    <div *ngIf="appointment.location.geoLat && appointment.location.geoLng" class="w-10rem mapsImage">
                        <a (click)="onOpenGoogleMaps($event,appointment)" href="#" aria-label="Open Google Maps"
                            i18n-aria-label="@@appointment-management-list.openGoogleMaps"><img class=" w-full"
                                loading="lazy" style="border-radius: 5px;"
                                [src]="apiURL + '/file-api/location-image/' + appointment.location.id + '?access_token=' + coreLibService.getJWTToken()"
                                role="presentation" alt=""></a>
                    </div>
                    <div class="font-light ml-2 LocationAddress" style="margin-top: -5px" role="text">
                        <div class="font-medium">{{appointment.location.title}}</div>
                        <div>
                            <span>{{appointment.location.street}}</span><br>
                            <span>{{appointment.location.postalCode}} {{appointment.location.city}}</span>
                        </div>
                    </div>
                </div>
                <div class="flex justify-content-end flex-wrap"
                    [ngClass]="{'mt-4':appointment.detailLink ||(appointment.onlineConference &&((appointment.ownRegistrations && appointment.ownRegistrations.length > 0 && appointment.registrationRequired === true) ||appointment.registrationRequired === false))}">
                    <button *ngIf="appointment.detailLink" pButton pRipple type="button"
                        class="ml-2 mt-2 p-button-secondary detailLinkButton" label="Read more"
                        i18n-label="@@appointment-management-list.more-info"
                        (click)="onOpenMoreInformation(appointment)"></button>

                    <button
                        *ngIf="(appointment.onlineConference) && ((appointment.ownRegistrations && appointment.ownRegistrations.length>0 && appointment.registrationRequired == true) || appointment.registrationRequired == false)"
                        pButton pRipple type="button" class="ml-2 mt-2 p-button-secondary conferenceButton"
                        label="Join Conference" icon="far fa-video"
                        i18n-label="@@appointment-management-list.join-conference"
                        (click)="joinConference(appointment)"></button>
                </div>

                <div *ngIf="appointment.feedbackAllowed && appointment.ownRegistrations.length == 0"
                    class="flex align-items-end flex-column mt-2 eventFeedback">
                    <label class="font-semibold" i18n="@@appointment-management-list.participate">Will you
                        participate?</label>
                    <div class="flex mt-2 mr-1">
                        <p-button icon="fa-light fa-thumbs-up font-semibold thumbsUp"
                            [styleClass]="feedbackType.Positive === appointment.ownFeedback?.status?'feedback-background-color-success':''"
                            [rounded]="true" severity="secondary"
                            (onClick)="onClickFeedback(appointment,feedbackType.Positive)"
                            [ariaLabel]="feedbackType.Positive === appointment.ownFeedback?.status? buttonLabels.participantFeedbackThumbUpActive : buttonLabels.participantFeedbackThumbUpInactive" />
                        <p-button icon="fa-light fa-thumbs-down font-semibold thumbsDown" [rounded]="true"
                            [styleClass]="feedbackType.Negative === appointment.ownFeedback?.status?'feedback-background-color-danger ml-2':'ml-2'"
                            severity="secondary" (onClick)="onClickFeedback(appointment,feedbackType.Negative)"
                            [ariaLabel]="feedbackType.Negative === appointment.ownFeedback?.status? buttonLabels.participantFeedbackThumbDownActive : buttonLabels.participantFeedbackThumbDownInactive" />
                        <p-button icon="fa-light fa-question text-white font-semibold questionMark" [rounded]="true"
                            [styleClass]="feedbackType.Maybe === appointment.ownFeedback?.status?'feedback-background-color-warning ml-2':'ml-2'"
                            (onClick)="onClickFeedback(appointment,feedbackType.Maybe)" severity="secondary"
                            [ariaLabel]="feedbackType.Maybe === appointment.ownFeedback?.status? buttonLabels.participantFeedbackMaybeActive : buttonLabels.participantFeedbackMaybeInactive" />
                    </div>
                </div>
                <div *ngIf="appointment.registrationRequired == true && isStartOfRegistrationReached(appointment)"
                    class="mt-4">
                    <lib-event-registration (closeEventRegistration)="onCloseSignupDetails($event)"
                        (pay)="onPay($event)" #ff [event]="appointment">
                    </lib-event-registration>
                </div>

                <p-button class="sr-only" i18n="appointment-management-list.SROnly.collapseButton" (onClick)="onToggleAppointmentDetail(appointment,false)">Hide details</p-button>
            </div>
        </div>
    </div>
</ng-template>

<p-dialog [focusOnShow]="false" i18n-header="@@appointment-management-list.event-reminder" header="Event Reminder"
    [(visible)]="dialogControl.showEventReminder" [modal]="true" [draggable]="false" [dismissableMask]="true" [focusTrap]="true" closeAriaLabel="Close" i18n-closeAriaLabel="@@appointment-management-list.event-reminder.Close"
    id="reminderDialog" (onShow)="onModalShow('reminderDialog')"
    *ngIf="dialogControl.showEventReminder" [breakpoints]="{'960px': '75vw', '640px': '90vw'}" [style]="{width: '50vw'}">
    <div class="mt-3 message">
        {{dialogControl.context.message}}
    </div>
    <div class="text-right">
        <p-button icon="far fa-check" severity="secondary" label="Ok" (onClick)="onReminderDone()"
            class="acceptButton"></p-button>
    </div>
</p-dialog>

<p-dialog [focusOnShow]="false" i18n-header="@@appointment-management-list.details.header" header="Event details" [focusTrap]="true" closeAriaLabel="Close" i18n-closeAriaLabel="@@appointment-management-list.details.Close" (onShow)="onModalShow('detailsDialog')"
    [(visible)]="dialogControl.showAppointmentDetailsPopup" [modal]="true" [draggable]="false" [dismissableMask]="true"
    *ngIf="dialogControl.showAppointmentDetailsPopup" [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
    id="detailsDialog" [style]="{width: '50vw'}">
    <ng-container
        *ngTemplateOutlet="appointmentTemplate;context:{appointment:dialogControl.context,collapsed:appointmentListControl[dialogControl.context.id]!= null?appointmentListControl[dialogControl.context.id].collapsed:false,eventRegistrationCollapsed:appointmentListControl[dialogControl.context.id]== null || appointmentListControl[dialogControl.context.id].eventRegistrationCollapsed == true,showCollapseButton:false}">
    </ng-container>
</p-dialog>

<p-dialog [focusOnShow]="false" i18n-header="@@appointment-management-list.signUpOverview.header" [focusTrap]="true" closeAriaLabel="Close" i18n-closeAriaLabel="@@appointment-management-list.signUpOverview.Close"
    (onShow)="onModalShow('signupOverviewDialog')"
    header="Participant overview" [(visible)]="dialogControl.showAppointmentSignUpOverview"
    *ngIf="dialogControl.showAppointmentSignUpOverview" [modal]="true" [draggable]="false"
    [style]="{width: '50vw', height: '80vh'}" [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
    id="signupOverviewDialog">
    <!--<lib-event-sign-ups-overview (closeEventSignUpsOverview)="onCloseEventSignUpsOverview($event)"
        [context]="dialogControl.context"></lib-event-sign-ups-overview>-->

    <app-event-participants-overview (close)="onCloseEventSignUpsOverview($event)"
        [context]="dialogControl.context"></app-event-participants-overview>
</p-dialog>

<p-dialog [focusOnShow]="false" header="Corrupt Filter" i18n-header="@@appointment-management-list.corruptfilter.header"
    [modal]="true" [(visible)]="dialogControl.corruptFilter" *ngIf="dialogControl.corruptFilter" [focusTrap]="true" closeAriaLabel="Close" i18n-closeAriaLabel="@@appointment-management-list.corruptfilter.Close"
    (onShow)="onModalShow('corruptFilterDialog')"
    [style]="{width: '85vw'}" id="corruptFilterDialog">
    <div i18n="@@appointment-management-list.corruptfilter.text" class="corruptedFilterText">
        We have identified that your filter settings include items that no longer exist. To prevent potential errors, we
        recommend resetting your filters.
    </div>
    <ng-template pTemplate="footer">
        <div class="flex-1">
            <div class="flex justify-content-center align-items-center">
                <p-button type="button" severity="secondary" class="w-max mt-3 md:mt-0 resetButton"
                    (click)="dialogControl.corruptFilter=false; resetFilter();" label="Reset filter"
                    i18n-label="@@appointment-management-list.corruptfilter.reset"></p-button>
                <p-button type="button" severity="secondary" class="w-max mt-3 md:mt-0 cancelButton"
                    (click)="dialogControl.corruptFilter=false" label="Cancel"
                    i18n-label="@@appointment-management-list.corruptfilter.cancel"></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>
<p-confirmDialog header="Confirm Changes" i18n-header="@@appointment-management-edit.confirm-changes"></p-confirmDialog>


<p-dialog [focusOnShow]="false" header="Participation feedback" i18n-header="@@appointment-management-list.feedbackComment.header" [modal]="true"
    [(visible)]="dialogControl.feedbackDialog.visible" *ngIf="dialogControl.feedbackDialog.visible" [focusTrap]="true" closeAriaLabel="Close" i18n-closeAriaLabel="@@appointment-management-list.feedbackComment.Close"
    (onShow)="onModalShow('feedbackDialog')"
    [style]="{width: '85vw'}" id="feedbackDialog">
    <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
        <div class="w-full">
            <textarea pInputTextarea class="block w-full" rows="6" [(ngModel)]="dialogControl.feedbackDialog.comment"
                placeholder="Enter a message to leave your feedback"
                i18n-placeholder="@@event-registration.unregistration-feedback-comment.placeholder"></textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex-1">
            <div class="flex justify-content-between align-items-center">
                <p-button type="button" severity="secondary" class="w-max mt-3 md:mt-0 cancelButton"
                    (click)="dialogControl.feedbackDialog.visible=false;" label="Cancel"
                    i18n-label="@@appointment-management-list.sendfeedback.cancel"></p-button>
                <p-button type="button" severity="secondary" class="w-max mt-3 md:mt-0 sendButton"
                    (click)="onSendFeedback()" label="Send Feedback"
                    i18n-label="@@appointment-management-list.sendfeedback.send"></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>
